<!--
  * name: NewsDeatil
  * description: 뉴스 페이지 상세 컴포넌트
-->
<template>
  <div>
    <bread-crumb location="NEWS" class="mb-42"></bread-crumb>
    <!-- <page-title class="mt-14 mb-18"><strong>botalab</strong> NEWS</page-title> -->
    <div class="container content" v-if="isLoaded" v-touch:swipe.left="prevDetail" v-touch:swipe.right="nextDetail">
      <div class="detail-top-style">
        <div>
          <h2 class="detail-top-style-tit">
            {{ news.title }}
          </h2>
        </div>
        <div class="detail-top-style-date">{{ $moment(news.createDatetime).format('YYYY. MM. DD') }}</div>
      </div>
      <div class="row detail-top-style">
        <div class="col-3 detail-top-style-label">
          <div
            class="label detail-top-style-label"
            :class="news.newsType.code.toLowerCase()"
          >
            {{ changeCRSNaming(news.newsType.text) }}
          </div>
        </div>
        <div class="col-9 detail-top-style-snsWrap">
          <!-- sns공유 버튼 그룹 -->
          <sns-share :title="news.title"/>
          <!-- sns공유 버튼 그룹 -->
        </div>
      </div>
      <div class="mt-3 contents-style" v-html="news.content" />
    </div>
    <!-- 하단 이전글, 목록, 다음글 그룹 -->
    <navi-detail-bottom
      @prevDetail="prevDetail" 
      @nextDetail="nextDetail"
      class="mt-14"
      pageName="NewsDetail"
      :prevId="news.forthBack.prevNewsId"
      :nextId="news.forthBack.nextNewsId"
      v-if="isLoaded"
      :news="news"
    />
    <!-- 하단 이전글, 목록, 다음글 그룹 -->
  </div>
</template>

<script>
import SnsShare from '@/components/page/SnsShare.vue';
import NaviDetailBottom from '@/views/news/detail/partial/NaviDetailBottom.vue';
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import PageTitle from '@/components/page/PageTitle.vue';
import { mapGetters } from 'vuex';
import newsApi from '@/apis/news';
import { log } from '@/utils/common';

export default {
  name: 'NewsDetail',
  components: {
    SnsShare,
    NaviDetailBottom,
    BreadCrumb,
    PageTitle,
  },
  props: ['newsId'],
  data() {
    return {
      type: null,
      news: null,
      isLoaded: false,
    };
  },
  watch: {
    newsId() {
      this.getNewsDetailData();
    },
  },
  computed: {
    ...mapGetters({
      storedPageData: 'page/getPageData',
    }),
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      if (this.storedPageData && this.storedPageData.pageName === 'News') {
        this.type = this.storedPageData.params.type;
      }
      this.getNewsDetailData();
    },
    // eslint-disable-next-line consistent-return
    async getNewsDetailData() {
      const result = await newsApi.getNewsDetail(this.newsId);
      if (this.chkResultCode(result)) return; // [2021.05.25 HP-156]
      if (result.data.error) {
        log('newsApi::getNewsDetail', 'error', result.data);
        return result.data;
      }
      this.news = result.data;
      this.isLoaded = true;
    },
    chkResultCode(result) {
      const returnValue = (result.code === '4004');
      if (returnValue) {
        alert('요청하신 뉴스를 찾을 수 없습니다.');
        this.$router.push("/news");
      }
      return returnValue;
    },
    changeCRSNaming(name) {
      if (name === 'CSR(사회공헌)') {
        return '사회공헌';
      }
      return name;
    },
    prevDetail() {
      if(this.news.forthBack.prevNewsId){
        return this.$router.push({
          name: 'NewsDetail',
          params: { newsId: this.news.forthBack.prevNewsId },
        });
      }else{
        return;
      }
    },
    nextDetail() {
      if(this.news.forthBack.nextNewsId){
        return this.$router.push({
          name: 'NewsDetail',
          params: { newsId: this.news.forthBack.nextNewsId },
        });
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.detail-top-style{
  margin-bottom: 1rem;
  &-label{
    float: none;
  }
}
.tit-style, .content{
  width: 80rem;
  @media (max-width: 1024px) {
    width: auto;
  }
  @media (max-width: $mobile-size) {
    margin-top: 11rem;
  }
}
.label{
  width: 8.6rem;
  height: 3.6rem;
  line-height: 3.7rem;
}
/deep/ .file{
  margin-bottom: 2rem;
  &--tit{
    background: url(~@/assets/images/common/i_file.png) left no-repeat;
    padding-left: 1.5rem;
  }
  &--down{
    border: solid 1px #ddd;
    padding: 1rem 1.5rem;
    background: url(~@/assets/images/common/i_down.png) 1.5rem no-repeat;
    padding-left: 4.5rem;
    span{
      font-size: 1.4rem;
      color: #999;
      margin-left: .5rem;
    }
  }
}
</style>
